export default function AnimatedBackground() {
  const gradientBaseStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 0,
    mixBlendMode: "hard-light", // Creates more intense, sophisticated color mixing
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        zIndex: 0,
        overflow: "hidden",
        background:
          "radial-gradient(circle at center, #1a1a3e 0%, #0a0e27 100%)", // Deep neutral dark
      }}
    >
      {/* --- LAYERED ATMOSPHERIC GRADIENTS --- */}

      {/* Deep Sea Glow - Bottom Left */}
      <div
        style={{
          ...gradientBaseStyle,
          background:
            "radial-gradient(circle at 0% 100%, #00D4FF 0%, transparent 50%)",
          animation: "pulseGlow 15s ease-in-out infinite alternate",
        }}
      />

      {/* Electric Magenta - Top Right */}
      <div
        style={{
          ...gradientBaseStyle,
          background:
            "radial-gradient(circle at 100% 0%, #FF006E 0%, transparent 50%)",
          animation: "pulseGlow 12s ease-in-out infinite alternate-reverse",
        }}
      />

      {/* Royal Purple - Floating Center-ish */}
      <div
        style={{
          ...gradientBaseStyle,
          background:
            "radial-gradient(circle at 50% 50%, #8338EC 0%, transparent 60%)",
          opacity: 0.4,
          animation: "drift 20s linear infinite",
        }}
      />

      {/* Amber Highlight - Bottom Right */}
      <div
        style={{
          ...gradientBaseStyle,
          background:
            "radial-gradient(circle at 80% 80%, #FFBE0B 0%, transparent 30%)",
          opacity: 0.3,
          animation: "pulseGlow 18s ease-in-out infinite",
        }}
      />

      {/* --- TEXTURE & VIGNETTE --- */}

      {/* 1. Grainy Texture (Crucial for a premium "Photoraphy" feel) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0.04,
          pointerEvents: "none",
          zIndex: 1,
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* 2. Deep Vignette (Frames your content) */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at center, transparent 20%, rgba(0,0,0,0.8) 100%)",
          zIndex: 2,
        }}
      />

      {/* 3. Final Glass Layer */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backdropFilter: "blur(40px) saturate(140%)",
          zIndex: 3,
        }}
      />

      <style>{`
        @keyframes pulseGlow {
          0% { opacity: 0.4; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.1); }
          100% { opacity: 0.4; transform: scale(1); }
        }

        @keyframes drift {
          0% { transform: translate(-5%, -5%) rotate(0deg); }
          50% { transform: translate(5%, 5%) rotate(5deg); }
          100% { transform: translate(-5%, -5%) rotate(0deg); }
        }
      `}</style>
    </div>
  );
}
